import React from 'react';
import { cn } from '../../utils/cn';

const Select = React.forwardRef(({ 
  children, 
  className, 
  ...props 
}, ref) => {
  return (
    <select
      ref={ref}
      className={cn('reddit-input cursor-pointer', className)}
      {...props}
    >
      {children}
    </select>
  );
});

Select.displayName = 'Select';

export default Select;